import axios from "axios";
import {API_URL} from "../const";

// console.log('---------->');
// console.log(API_URL);

const CoreClient = axios.create({
    baseURL: API_URL,
    headers: {"Content-Type": "application/json"}
})

export const coreGetPrice = (startLocation, endLocation, babyChair, emptyTrunk, animalTransportation, driverAssistance, coupon, telegramAuthToken, femaleCrew, priorityAmount) => {
    return CoreClient.post(
        'orders/getPrice/',
        {
            start_location: startLocation,
            end_location: endLocation,
            baby_chair: babyChair,
            empty_trunk: emptyTrunk,
            animal_transportation: animalTransportation,
            driver_assistance: driverAssistance,
            coupon_id: coupon,
            telegram_auth_token: telegramAuthToken,
            female_crew: femaleCrew,
            priority_amount: priorityAmount || 0,
        }
    );
}

export const coreGetUser = token => {
    // alert(API_URL);
    return CoreClient.get(
        `users/GetUserApiByTelegramTokenAuth/${token}/`
    )
}

export const coreGetUserById = chat_id => {
    return CoreClient.post(
        `users/getUserFromTelegram/`,
        {
            chat_id: chat_id,
        }
    )
}

export const coreGetUserActiveOrder = token => {
    return CoreClient.get(
        `orders/getActiveByTelegramAuthToken/${token}/`
    )
}

export const coreGetMaxUser = maxChatId => {
    return CoreClient.get(
        `users/GetUserApiByMaxChatId/${maxChatId}/`
    )
}

export const coreCreateOrderFromMax = (orderData) => {
    return CoreClient.post('orders/createOrderFromMax/', orderData)
}
